/// <amd-module name="Wit/WorkItems/WorkItemModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { WorkItemTypesModule } from "Wit/WorkItemTypes/Module/WorkItemTypesModule";

import { workItemsReducer } from "./Redux//WorkItemReducer";
import { workItemSaga } from "./Redux/Sagas/WorkItemSaga";
import { IWorkItemAwareState } from "./WorkItemContracts";

const _workItemModule: ISagaModule<IWorkItemAwareState> = {
    id: "wit-workitems",
    reducerMap: {
        workItemState: workItemsReducer
    },
    sagas: [workItemSaga]
};

export const WorkItemsModule = [WorkItemTypesModule, _workItemModule];
